import { render, staticRenderFns } from "./RemoveGeometryConfirmation.vue?vue&type=template&id=0f4a4435&scoped=true&"
import script from "./RemoveGeometryConfirmation.vue?vue&type=script&lang=js&"
export * from "./RemoveGeometryConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./RemoveGeometryConfirmation.vue?vue&type=style&index=0&id=0f4a4435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4a4435",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDialog})
